import httpClient from '../../shared/services/httpClient';

export const Collection = async (placeId: number, name: string) => {
  const body = {
    name: name,
  };
  const response = await httpClient.post(`/media/collection/place/${placeId}`, body);
  return response.data;
};

export const CollectionDelete = async (collectionId: number) => {
  const response = await httpClient.delete(`/media/collection/${collectionId}`);
  return response.data;
};

export const CollectionEdit = async (collectionId: number, name: string) => {
  const body = {
    id: collectionId,
    name: name,
  };
  const response = await httpClient.put(`/media/collection`, body);
  return response.data;
};
